import React, { useRef } from "react";
import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import { Instagram } from "@material-ui/icons";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_e7rqvff",
        "template_0l8x14n",
        form.current,
        "EdoyPmZuC4SMYvsDd"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <section className="contact" id="contact">
      <h5>Get in touch</h5>
      <h2>Contact me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>Deepnrng007@gmail.com</h5>
            <a href="mailto:deepnrng007@gmail.com" target="_blank">
              Send a message
            </a>
          </article>
          <article className="contact__option">
            <Instagram className="contact__option-icon" />
            <h4>Instagram</h4>
            <h5>Deep.007_</h5>
            <a
              href="https://instagram.com/deep.007_?igshid=NDk5N2NlZjQ="
              target="_blank"
            >
              Visit Profile
            </a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4>Whatsapp</h4>
            {/* <h5>+91 9671730505</h5> */}
            <a
              href="https://api.whatsapp.com/send?phone=+918881560005"
              target="_blank"
            >
              Send a message
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          ></input>
          <input
            type="text"
            name="email"
            placeholder="Your Email Address"
            required
          ></input>
          <textarea
            name="message"
            rows="7"
            placeholder="Write your message here"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
